import React, { useState, useEffect, useRef } from 'react'

import { Box } from '@material-ui/core'
import { useFormContext } from 'react-hook-form'

import useStyles from './styles'

const Form = () => {
  const [inputValues, setInputValues] = useState(Array(5).fill(''))
  const [selectedInput, setSelectedInput] = useState(0)

  const classes = useStyles()
  const ref = useRef()
  const { setValue, errors, register } = useFormContext()

  const normalizeIndex = (index) => {
    if (index > 4) return 4
    if (index < 0) return 0

    return index
  }

  const handleInput = (index, value) => {
    if (value !== '' && !/^\d$/.test(value)) return

    setInputValues([
      ...inputValues.slice(0, index),
      value,
      ...inputValues.slice(index + 1),
    ])

    if (value !== '' && index !== 4) handleForward(index)
  }

  const handleForward = (index) => setSelectedInput(normalizeIndex(index + 1))

  const handleBack = (e) => {
    if (e.key !== 'Backspace') return
    if (inputValues[selectedInput] !== '') return

    setSelectedInput((selectedInput) => normalizeIndex(selectedInput - 1))
  }

  const handlePaste = (e) => {
    const pastedValue = e.clipboardData.getData('text')
    setInputValues((inputValues) =>
      inputValues.map((_, index) => pastedValue[index] || ''),
    )
  }

  const handleFocus = (e) => {
    const inputIndex = e.target.id

    if (selectedInput !== inputIndex) setSelectedInput(inputIndex)
  }

  useEffect(() => {
    document.getElementById(normalizeIndex(selectedInput)).focus()
  }, [selectedInput])

  useEffect(() => {
    setValue('code', inputValues.join(''))
    // eslint-disable-next-line
  }, [inputValues])

  return (
    <Box className={classes.container} my={4}>
      <input type="hidden" name="code" ref={register} />

      {inputValues.map((value, index) => (
        <input
          key={index}
          id={index}
          className={`${classes.input} ${!!errors.code && classes.inputError}`}
          maxLength="1"
          onChange={(e) => handleInput(index, e.target.value)}
          onFocus={handleFocus}
          onKeyDown={(e) => handleBack(e)}
          onPaste={handlePaste}
          ref={ref}
          type="text"
          value={value}
        />
      ))}
    </Box>
  )
}

export default Form
